module.exports = __webpack_public_path__ + "img/icon-thumbsup.a78c5397.svg";